export default __webpack_public_path__ + "static/media/Boots of the Death God.1148a530.jpg";